import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  class: "visually-hidden",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_5 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_6 = ["href", "aria-label", "title"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["disabled", "aria-label", "title", "onClick"]
const _hoisted_9 = {
  key: 1,
  class: "visually-hidden"
}
const _hoisted_10 = ["aria-labelledby"]
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "row g-3" }
const _hoisted_13 = { class: "col-12 col-lg-6" }
const _hoisted_14 = ["for"]
const _hoisted_15 = ["id", "disabled", "aria-invalid", "aria-describedby"]
const _hoisted_16 = ["id"]
const _hoisted_17 = { class: "col-12 col-sm-6 col-lg-3" }
const _hoisted_18 = { class: "col-12 col-sm-6 col-lg-3" }
const _hoisted_19 = ["for"]
const _hoisted_20 = ["id", "max", "disabled", "aria-invalid", "aria-describedby"]
const _hoisted_21 = ["id"]
const _hoisted_22 = { class: "col-12 col-lg-9" }
const _hoisted_23 = ["for"]
const _hoisted_24 = ["id", "disabled", "aria-invalid", "aria-describedby"]
const _hoisted_25 = ["id"]
const _hoisted_26 = { class: "col-12 col-lg-3 d-flex align-items-end" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  "aria-hidden": "true"
}
const _hoisted_29 = {
  key: 1,
  class: "mdi mdi-paperclip me-1",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConsulteGrid = _resolveComponent("ConsulteGrid")!
  const _component_DropDownConsulte = _resolveComponent("DropDownConsulte")!

  return (_openBlock(), _createElementBlock("section", {
    class: "card",
    "aria-labelledby": `${_ctx.idBase}-titulo`
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", {
        id: `${_ctx.idBase}-titulo`,
        class: "h5"
      }, "Documentos do ambiente", 8, _hoisted_3),
      _cache[12] || (_cache[12] = _createElementVNode("p", { class: "form-text mt-0" }, " Plantas, laudos, alvarás, contratos e fotos do ambiente. PDF, JPG ou PNG de até 10 MB. ", -1)),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.anuncio), 1),
      (_ctx.erroGeral)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.erroGeral), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_ConsulteGrid, {
        columns: _ctx.colunas,
        "data-source": _ctx.dataSource,
        "show-views-manager": false,
        "titulo-relatorio": "Documentos do ambiente",
        "nome-arquivo-relatorio": "Documentos_ambiente"
      }, {
        dataDocumento: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(_ctx.formatarData(row.dataDocumento)), 1)
        ]),
        nomeArquivo: _withCtx(({ row }) => [
          (row.url)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: row.url,
                target: "_blank",
                rel: "noopener noreferrer",
                "aria-label": `Abrir o arquivo ${row.nomeArquivo} (abre em nova aba)`,
                title: `Abrir ${row.nomeArquivo} em nova aba`
              }, [
                _cache[5] || (_cache[5] = _createElementVNode("i", {
                  class: "mdi mdi-paperclip me-1",
                  "aria-hidden": "true"
                }, null, -1)),
                _createTextVNode(_toDisplayString(row.nomeArquivo), 1)
              ], 8, _hoisted_6))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                _createTextVNode(_toDisplayString(row.nomeArquivo) + " ", 1),
                _cache[6] || (_cache[6] = _createElementVNode("small", { class: "d-block text-danger" }, "Arquivo indisponível no armazenamento", -1))
              ]))
        ]),
        tamanho: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(_ctx.formatarTamanho(row.tamanho)), 1)
        ]),
        acoes: _withCtx(({ row }) => [
          (_ctx.permissao.excluir)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-sm btn-outline-danger",
                disabled: _ctx.ocupado,
                "aria-label": `Excluir o documento ${row.descricao}`,
                title: `Excluir o documento ${row.descricao}`,
                onClick: ($event: any) => (_ctx.excluir(row))
              }, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("i", {
                  class: "mdi mdi-delete",
                  "aria-hidden": "true"
                }, null, -1),
                _createElementVNode("span", { class: "ms-1" }, "Excluir", -1)
              ]))], 8, _hoisted_8))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, "Sem ações disponíveis"))
        ]),
        _: 1
      }, 8, ["columns", "data-source"]),
      (_ctx.permissao.incluir)
        ? (_openBlock(), _createElementBlock("form", {
            key: 1,
            class: "mt-4",
            novalidate: "",
            "aria-labelledby": `${_ctx.idBase}-novo`,
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.enviar && _ctx.enviar(...args)), ["prevent"]))
          }, [
            _createElementVNode("h3", {
              id: `${_ctx.idBase}-novo`,
              class: "h6"
            }, "Anexar documento", 8, _hoisted_11),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", {
                  for: `${_ctx.idBase}-descricao`,
                  class: "form-label"
                }, [...(_cache[8] || (_cache[8] = [
                  _createTextVNode(" Descrição ", -1),
                  _createElementVNode("span", { "aria-hidden": "true" }, "*", -1)
                ]))], 8, _hoisted_14),
                _withDirectives(_createElementVNode("input", {
                  id: `${_ctx.idBase}-descricao`,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.novo.descricao) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.erros.descricao }]),
                  maxlength: "200",
                  required: "",
                  autocomplete: "off",
                  disabled: _ctx.ocupado,
                  "aria-invalid": _ctx.erros.descricao ? 'true' : undefined,
                  "aria-describedby": _ctx.erros.descricao ? `${_ctx.idBase}-descricao-erro` : undefined
                }, null, 10, _hoisted_15), [
                  [_vModelText, _ctx.novo.descricao]
                ]),
                (_ctx.erros.descricao)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      id: `${_ctx.idBase}-descricao-erro`,
                      class: "invalid-feedback d-block"
                    }, _toDisplayString(_ctx.erros.descricao), 9, _hoisted_16))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_DropDownConsulte, {
                  id: `${_ctx.idBase}-tipo`,
                  modelValue: _ctx.novo.tipoDocumento,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.novo.tipoDocumento) = $event)),
                  modelModifiers: { number: true },
                  array: _ctx.tiposDocumento,
                  "row-label": "texto",
                  "row-value": "valor",
                  label: "Tipo do documento",
                  placeholder: "Selecione o tipo",
                  required: "",
                  disabled: _ctx.ocupado,
                  "mensagem-erro": _ctx.erros.tipoDocumento
                }, null, 8, ["id", "modelValue", "array", "disabled", "mensagem-erro"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("label", {
                  for: `${_ctx.idBase}-data`,
                  class: "form-label"
                }, [...(_cache[9] || (_cache[9] = [
                  _createTextVNode(" Data de criação ", -1),
                  _createElementVNode("span", { "aria-hidden": "true" }, "*", -1)
                ]))], 8, _hoisted_19),
                _withDirectives(_createElementVNode("input", {
                  id: `${_ctx.idBase}-data`,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.novo.dataDocumento) = $event)),
                  type: "date",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.erros.dataDocumento }]),
                  max: _ctx.hoje,
                  required: "",
                  disabled: _ctx.ocupado,
                  "aria-invalid": _ctx.erros.dataDocumento ? 'true' : undefined,
                  "aria-describedby": _ctx.erros.dataDocumento ? `${_ctx.idBase}-data-erro` : undefined
                }, null, 10, _hoisted_20), [
                  [_vModelText, _ctx.novo.dataDocumento]
                ]),
                (_ctx.erros.dataDocumento)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      id: `${_ctx.idBase}-data-erro`,
                      class: "invalid-feedback d-block"
                    }, _toDisplayString(_ctx.erros.dataDocumento), 9, _hoisted_21))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", {
                  for: `${_ctx.idBase}-arquivo`,
                  class: "form-label"
                }, [...(_cache[10] || (_cache[10] = [
                  _createTextVNode(" Arquivo (PDF, JPG ou PNG, até 10 MB) ", -1),
                  _createElementVNode("span", { "aria-hidden": "true" }, "*", -1)
                ]))], 8, _hoisted_23),
                _createElementVNode("input", {
                  id: `${_ctx.idBase}-arquivo`,
                  ref: "campoArquivo",
                  type: "file",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.erros.arquivo }]),
                  accept: "application/pdf,image/png,image/jpeg,.pdf,.png,.jpg,.jpeg",
                  required: "",
                  disabled: _ctx.ocupado,
                  "aria-invalid": _ctx.erros.arquivo ? 'true' : undefined,
                  "aria-describedby": _ctx.erros.arquivo ? `${_ctx.idBase}-arquivo-erro` : undefined,
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selecionarArquivo && _ctx.selecionarArquivo(...args)))
                }, null, 42, _hoisted_24),
                (_ctx.erros.arquivo)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      id: `${_ctx.idBase}-arquivo-erro`,
                      class: "invalid-feedback d-block"
                    }, _toDisplayString(_ctx.erros.arquivo), 9, _hoisted_25))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary w-100",
                  disabled: _ctx.ocupado
                }, [
                  (_ctx.ocupado)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                    : (_openBlock(), _createElementBlock("i", _hoisted_29)),
                  _cache[11] || (_cache[11] = _createTextVNode(" Anexar documento ", -1))
                ], 8, _hoisted_27)
              ])
            ])
          ], 40, _hoisted_10))
        : _createCommentVNode("", true)
    ])
  ], 8, _hoisted_1))
}